module.exports = __webpack_public_path__ + "c2fa751546e42fdb877d8dc1f1f4cd38.png";